import React from 'react'
import HeroSection from '../components/HeroSection'

const HomePage: React.FC = () => {
  return (
    <div>
      <HeroSection />
    </div>
  )
}

export default HomePage
